export default [
  {
    region: "West",
    record_day: "2024-01-01",
    product_category: "egg12ct",
    average_price: 8.659,
  },
  {
    region: "West",
    record_day: "2024-01-01",
    product_category: "beef1lb",
    average_price: 5.563,
  },
  {
    region: "West",
    record_day: "2024-02-01",
    product_category: "egg12ct",
    average_price: 8.679,
  },
  {
    region: "West",
    record_day: "2024-02-01",
    product_category: "beef1lb",
    average_price: 5.495,
  },
  {
    region: "West",
    record_day: "2024-03-01",
    product_category: "egg12ct",
    average_price: 8.697,
  },
  {
    region: "West",
    record_day: "2024-03-01",
    product_category: "beef1lb",
    average_price: 5.359,
  },
  {
    region: "West",
    record_day: "2024-04-01",
    product_category: "egg12ct",
    average_price: 8.717,
  },
  {
    region: "West",
    record_day: "2024-04-01",
    product_category: "beef1lb",
    average_price: 5.52,
  },
  {
    region: "West",
    record_day: "2024-05-01",
    product_category: "egg12ct",
    average_price: 8.736,
  },
  {
    region: "West",
    record_day: "2024-05-01",
    product_category: "beef1lb",
    average_price: 5.616,
  },
  {
    region: "West",
    record_day: "2024-06-01",
    product_category: "egg12ct",
    average_price: 8.755,
  },
  {
    region: "West",
    record_day: "2024-06-01",
    product_category: "beef1lb",
    average_price: 5.708,
  },
  {
    region: "West",
    record_day: "2024-07-01",
    product_category: "egg12ct",
    average_price: 8.774,
  },
  {
    region: "West",
    record_day: "2024-07-01",
    product_category: "beef1lb",
    average_price: 5.731,
  },
  {
    region: "West",
    record_day: "2024-08-01",
    product_category: "egg12ct",
    average_price: 8.793,
  },
  {
    region: "West",
    record_day: "2024-08-01",
    product_category: "beef1lb",
    average_price: 5.881,
  },
  {
    region: "West",
    record_day: "2024-09-01",
    product_category: "egg12ct",
    average_price: 8.813,
  },
  {
    region: "West",
    record_day: "2024-09-01",
    product_category: "beef1lb",
    average_price: 5.993,
  },
  {
    region: "West",
    record_day: "2024-10-01",
    product_category: "egg12ct",
    average_price: 8.832,
  },
  {
    region: "West",
    record_day: "2024-10-01",
    product_category: "beef1lb",
    average_price: 5.806,
  },
  {
    region: "West",
    record_day: "2024-11-01",
    product_category: "egg12ct",
    average_price: 8.851,
  },
  {
    region: "West",
    record_day: "2024-11-01",
    product_category: "beef1lb",
    average_price: 5.916,
  },
  {
    region: "West",
    record_day: "2024-12-01",
    product_category: "egg12ct",
    average_price: 8.87,
  },
  {
    region: "West",
    record_day: "2024-12-01",
    product_category: "beef1lb",
    average_price: 5.886,
  },
  {
    region: "West",
    record_day: "2025-01-01",
    product_category: "egg12ct",
    average_price: 9.09,
  },
  {
    region: "West",
    record_day: "2025-01-01",
    product_category: "beef1lb",
    average_price: 5.735,
  },
  {
    region: "West",
    record_day: "2025-02-01",
    product_category: "egg12ct",
    average_price: 9.311,
  },
  {
    region: "West",
    record_day: "2025-02-01",
    product_category: "beef1lb",
    average_price: 5.934,
  },
  {
    region: "West",
    record_day: "2025-03-01",
    product_category: "egg12ct",
    average_price: 9.51,
  },
  {
    region: "West",
    record_day: "2025-03-01",
    product_category: "beef1lb",
    average_price: 6.125,
  },
  {
    region: "West",
    record_day: "2025-04-01",
    product_category: "egg12ct",
    average_price: 9.58,
  },
  {
    region: "West",
    record_day: "2025-05-01",
    product_category: "egg12ct",
    average_price: 9.04,
  },
  {
    region: "West",
    record_day: "2025-06-01",
    product_category: "egg12ct",
    average_price: 9.51,
  },
  {
    region: "West",
    record_day: "2025-06-01",
    product_category: "beef1lb",
    average_price: 6.29,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-01-01",
    product_category: "egg12ct",
    average_price: 2.342,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-01-01",
    product_category: "beef1lb",
    average_price: 4.959,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-01-01",
    product_category: "coffee11oz",
    average_price: 6.382,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-02-01",
    product_category: "egg12ct",
    average_price: 2.908,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-02-01",
    product_category: "beef1lb",
    average_price: 5.215,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-02-01",
    product_category: "coffee11oz",
    average_price: 6.57,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-03-01",
    product_category: "egg12ct",
    average_price: 2.757,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-03-01",
    product_category: "beef1lb",
    average_price: 5.397,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-03-01",
    product_category: "coffee11oz",
    average_price: 5.921,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-04-01",
    product_category: "egg12ct",
    average_price: 2.589,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-04-01",
    product_category: "beef1lb",
    average_price: 5.19,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-04-01",
    product_category: "coffee11oz",
    average_price: 6.064,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-05-01",
    product_category: "egg12ct",
    average_price: 2.456,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-05-01",
    product_category: "beef1lb",
    average_price: 5.412,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-06-01",
    product_category: "egg12ct",
    average_price: 2.618,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-06-01",
    product_category: "beef1lb",
    average_price: 5.801,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-07-01",
    product_category: "egg12ct",
    average_price: 3.05,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-07-01",
    product_category: "beef1lb",
    average_price: 5.739,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-08-01",
    product_category: "egg12ct",
    average_price: 3.171,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-08-01",
    product_category: "beef1lb",
    average_price: 5.742,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-08-01",
    product_category: "coffee11oz",
    average_price: 6.445,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-09-01",
    product_category: "egg12ct",
    average_price: 3.655,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-09-01",
    product_category: "beef1lb",
    average_price: 5.889,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-09-01",
    product_category: "coffee11oz",
    average_price: 7.019,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-10-01",
    product_category: "egg12ct",
    average_price: 3.173,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-10-01",
    product_category: "beef1lb",
    average_price: 5.875,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-10-01",
    product_category: "coffee11oz",
    average_price: 7.18,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-11-01",
    product_category: "egg12ct",
    average_price: 3.935,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-11-01",
    product_category: "beef1lb",
    average_price: 5.979,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-12-01",
    product_category: "egg12ct",
    average_price: 4.159,
  },
  {
    region: "Midwest Urban",
    record_day: "2024-12-01",
    product_category: "beef1lb",
    average_price: 5.805,
  },
  {
    region: "Midwest Urban",
    record_day: "2025-01-01",
    product_category: "egg12ct",
    average_price: 4.821,
  },
  {
    region: "Midwest Urban",
    record_day: "2025-01-01",
    product_category: "beef1lb",
    average_price: 5.89,
  },
  {
    region: "Midwest Urban",
    record_day: "2025-02-01",
    product_category: "egg12ct",
    average_price: 5.892,
  },
  {
    region: "Midwest Urban",
    record_day: "2025-02-01",
    product_category: "beef1lb",
    average_price: 6.105,
  },
  {
    region: "Midwest Urban",
    record_day: "2025-03-01",
    product_category: "egg12ct",
    average_price: 6.397,
  },
  {
    region: "Midwest Urban",
    record_day: "2025-03-01",
    product_category: "beef1lb",
    average_price: 6.208,
  },
  {
    region: "Midwest Urban",
    record_day: "2025-04-01",
    product_category: "egg12ct",
    average_price: 5.471,
  },
  {
    region: "Midwest Urban",
    record_day: "2025-04-01",
    product_category: "beef1lb",
    average_price: 6.177,
  },
  {
    region: "Midwest Urban",
    record_day: "2025-05-01",
    product_category: "egg12ct",
    average_price: 4.952,
  },
  {
    region: "Northeast",
    record_day: "2024-01-01",
    product_category: "egg12ct",
    average_price: 2.877,
  },
  {
    region: "Northeast",
    record_day: "2024-01-01",
    product_category: "beef1lb",
    average_price: 5.412,
  },
  {
    region: "Northeast",
    record_day: "2024-02-01",
    product_category: "egg12ct",
    average_price: 3.348,
  },
  {
    region: "Northeast",
    record_day: "2024-02-01",
    product_category: "beef1lb",
    average_price: 5.531,
  },
  {
    region: "Northeast",
    record_day: "2024-03-01",
    product_category: "egg12ct",
    average_price: 3.385,
  },
  {
    region: "Northeast",
    record_day: "2024-03-01",
    product_category: "beef1lb",
    average_price: 5.48,
  },
  {
    region: "Northeast",
    record_day: "2024-04-01",
    product_category: "egg12ct",
    average_price: 3.328,
  },
  {
    region: "Northeast",
    record_day: "2024-04-01",
    product_category: "beef1lb",
    average_price: 5.528,
  },
  {
    region: "Northeast",
    record_day: "2024-05-01",
    product_category: "egg12ct",
    average_price: 3.211,
  },
  {
    region: "Northeast",
    record_day: "2024-05-01",
    product_category: "beef1lb",
    average_price: 5.402,
  },
  {
    region: "Northeast",
    record_day: "2024-06-01",
    product_category: "egg12ct",
    average_price: 3.164,
  },
  {
    region: "Northeast",
    record_day: "2024-06-01",
    product_category: "beef1lb",
    average_price: 5.668,
  },
  {
    region: "Northeast",
    record_day: "2024-07-01",
    product_category: "egg12ct",
    average_price: 3.433,
  },
  {
    region: "Northeast",
    record_day: "2024-07-01",
    product_category: "beef1lb",
    average_price: 5.62,
  },
  {
    region: "Northeast",
    record_day: "2024-08-01",
    product_category: "egg12ct",
    average_price: 3.553,
  },
  {
    region: "Northeast",
    record_day: "2024-08-01",
    product_category: "beef1lb",
    average_price: 5.805,
  },
  {
    region: "Northeast",
    record_day: "2024-09-01",
    product_category: "egg12ct",
    average_price: 4.111,
  },
  {
    region: "Northeast",
    record_day: "2024-09-01",
    product_category: "beef1lb",
    average_price: 5.836,
  },
  {
    region: "Northeast",
    record_day: "2024-10-01",
    product_category: "egg12ct",
    average_price: 3.717,
  },
  {
    region: "Northeast",
    record_day: "2024-10-01",
    product_category: "beef1lb",
    average_price: 5.74,
  },
  {
    region: "Northeast",
    record_day: "2024-11-01",
    product_category: "beef1lb",
    average_price: 5.812,
  },
  {
    region: "Northeast",
    record_day: "2024-12-01",
    product_category: "beef1lb",
    average_price: 5.917,
  },
  {
    region: "Northeast",
    record_day: "2025-01-01",
    product_category: "beef1lb",
    average_price: 5.844,
  },
  {
    region: "Northeast",
    record_day: "2025-02-01",
    product_category: "beef1lb",
    average_price: 5.812,
  },
  {
    region: "Northeast",
    record_day: "2025-03-01",
    product_category: "beef1lb",
    average_price: 6.05,
  },
  {
    region: "Northeast",
    record_day: "2025-04-01",
    product_category: "beef1lb",
    average_price: 6.04,
  },
  {
    region: "Northeast",
    record_day: "2025-05-01",
    product_category: "beef1lb",
    average_price: 6.137,
  },
  {
    region: "South",
    record_day: "2024-01-01",
    product_category: "egg12ct",
    average_price: 2.28,
  },
  {
    region: "South",
    record_day: "2024-01-01",
    product_category: "beef1lb",
    average_price: 4.774,
  },
  {
    region: "South",
    record_day: "2024-01-01",
    product_category: "coffee11oz",
    average_price: 6.146,
  },
  {
    region: "South",
    record_day: "2024-02-01",
    product_category: "egg12ct",
    average_price: 2.712,
  },
  {
    region: "South",
    record_day: "2024-02-01",
    product_category: "beef1lb",
    average_price: 4.699,
  },
  {
    region: "South",
    record_day: "2024-02-01",
    product_category: "coffee11oz",
    average_price: 6.004,
  },
  {
    region: "South",
    record_day: "2024-03-01",
    product_category: "egg12ct",
    average_price: 2.81,
  },
  {
    region: "South",
    record_day: "2024-03-01",
    product_category: "beef1lb",
    average_price: 4.841,
  },
  {
    region: "South",
    record_day: "2024-03-01",
    product_category: "coffee11oz",
    average_price: 5.931,
  },
  {
    region: "South",
    record_day: "2024-04-01",
    product_category: "egg12ct",
    average_price: 2.642,
  },
  {
    region: "South",
    record_day: "2024-04-01",
    product_category: "beef1lb",
    average_price: 4.97,
  },
  {
    region: "South",
    record_day: "2024-04-01",
    product_category: "coffee11oz",
    average_price: 6.012,
  },
  {
    region: "South",
    record_day: "2024-05-01",
    product_category: "egg12ct",
    average_price: 2.479,
  },
  {
    region: "South",
    record_day: "2024-05-01",
    product_category: "beef1lb",
    average_price: 4.798,
  },
  {
    region: "South",
    record_day: "2024-05-01",
    product_category: "coffee11oz",
    average_price: 5.963,
  },
  {
    region: "South",
    record_day: "2024-06-01",
    product_category: "egg12ct",
    average_price: 2.352,
  },
  {
    region: "South",
    record_day: "2024-06-01",
    product_category: "beef1lb",
    average_price: 4.967,
  },
  {
    region: "South",
    record_day: "2024-06-01",
    product_category: "coffee11oz",
    average_price: 6.134,
  },
  {
    region: "South",
    record_day: "2024-07-01",
    product_category: "egg12ct",
    average_price: 2.751,
  },
  {
    region: "South",
    record_day: "2024-07-01",
    product_category: "beef1lb",
    average_price: 5.013,
  },
  {
    region: "South",
    record_day: "2024-07-01",
    product_category: "coffee11oz",
    average_price: 6.187,
  },
  {
    region: "South",
    record_day: "2024-08-01",
    product_category: "egg12ct",
    average_price: 2.934,
  },
  {
    region: "South",
    record_day: "2024-08-01",
    product_category: "beef1lb",
    average_price: 5.096,
  },
  {
    region: "South",
    record_day: "2024-08-01",
    product_category: "coffee11oz",
    average_price: 6.159,
  },
  {
    region: "South",
    record_day: "2024-09-01",
    product_category: "egg12ct",
    average_price: 3.747,
  },
  {
    region: "South",
    record_day: "2024-09-01",
    product_category: "beef1lb",
    average_price: 5.088,
  },
  {
    region: "South",
    record_day: "2024-09-01",
    product_category: "coffee11oz",
    average_price: 6.282,
  },
  {
    region: "South",
    record_day: "2024-10-01",
    product_category: "egg12ct",
    average_price: 3.298,
  },
  {
    region: "South",
    record_day: "2024-10-01",
    product_category: "beef1lb",
    average_price: 5.157,
  },
  {
    region: "South",
    record_day: "2024-10-01",
    product_category: "coffee11oz",
    average_price: 6.47,
  },
  {
    region: "South",
    record_day: "2024-11-01",
    product_category: "egg12ct",
    average_price: 3.401,
  },
  {
    region: "South",
    record_day: "2024-11-01",
    product_category: "beef1lb",
    average_price: 5.164,
  },
  {
    region: "South",
    record_day: "2024-12-01",
    product_category: "egg12ct",
    average_price: 3.907,
  },
  {
    region: "South",
    record_day: "2024-12-01",
    product_category: "beef1lb",
    average_price: 5.122,
  },
  {
    region: "South",
    record_day: "2025-01-01",
    product_category: "egg12ct",
    average_price: 4.74,
  },
  {
    region: "South",
    record_day: "2025-01-01",
    product_category: "beef1lb",
    average_price: 5.096,
  },
  {
    region: "South",
    record_day: "2025-02-01",
    product_category: "egg12ct",
    average_price: 5.453,
  },
  {
    region: "South",
    record_day: "2025-02-01",
    product_category: "beef1lb",
    average_price: 5.147,
  },
  {
    region: "South",
    record_day: "2025-03-01",
    product_category: "egg12ct",
    average_price: 5.907,
  },
  {
    region: "South",
    record_day: "2025-03-01",
    product_category: "beef1lb",
    average_price: 5.275,
  },
  {
    region: "South",
    record_day: "2025-04-01",
    product_category: "egg12ct",
    average_price: 4.803,
  },
  {
    region: "South",
    record_day: "2025-04-01",
    product_category: "beef1lb",
    average_price: 5.353,
  },
  {
    region: "South",
    record_day: "2025-05-01",
    product_category: "egg12ct",
    average_price: 4.24,
  },
  {
    region: "South",
    record_day: "2025-05-01",
    product_category: "beef1lb",
    average_price: 5.502,
  },
  {
    region: "South",
    record_day: "2025-05-01",
    product_category: "coffee11oz",
    average_price: 7.634,
  },
];
